import moment from 'moment';

export const isStringEmpty = str => !str || str === '';

export const formatTimespan = timespan => {
  const duration = moment.duration(timespan, 'T');
  let formatted = `${duration.hours()}h ${duration.minutes()}m ${duration.seconds()}s`;

  const days = duration.days();
  if (days > 0) {
    formatted = `${days}d ${formatted}`;
  }

  return formatted;
};
